import {FinalWidget, EventsSet, mergeObjects} from './finalWidgets.js';

export default class FinalBox extends FinalWidget{

	static #instances = [];
	static #effective_index = -1;

	static #plugins = [];

	params = null;
	content_index = 0;

	constructor( source, params ){

		super();

		if( this.constructor._defaults === null )
			this.constructor._initDefaults();

		// Getting effective params
		this.params = mergeObjects(params ?? {}, this.constructor._defaults);

		// Making nodes
		this.overlay = document.createElement("div");
		this.overlay.classList.add('finalBoxOverlay');
		this.wrapper = document.createElement("div");
		this.wrapper.classList.add('finalBox');

		this.overlay.append(this.wrapper);


		this.content = [ ...source.content.cloneNode(true).children ];
		this.render();

		// Cheking instances
		// By default clearout all instances
		if( this.constructor.#instances.length ){
			this.constructor.#instances.map((instance) => instance.overlay.remove() )
			this.constructor.#instances = [];
		}


		// Running events
		this.applyEvents('open_start', 'finalbox', [this.content]);

		document.body.prepend(this.overlay);

		// Running events
		this.applyEvents('open_end', 'finalbox', [this.content]);

		this.constructor.#instances.push( this );
		this.constructor.#effective_index = this.constructor.#instances.length - 1;


	}	

	render(){
		[ ... this.wrapper.children].map((el) => {
			// TODO:: need some kind of lock - to make some elements stay when removing old contnet
			el.remove();
		});

		this.wrapper.append( this.content[ this.content_index ] );
	}



	destroy(){
		this.constructor.#instances = this.constructor.#instances.filter((i) => i != this);
	}


	// Constructors
	static fromTemplate( source, params ){
		return new this( source, params );
	}
	static fromUri( source, params, fetch_params ){

		return fetch(source)
			.then(( r ) => {

				if( fetch_params ){

					return (
						fetch_params instanceof Function
						? fetch_params( r )
						: fetch_params.response_preprocess( r )
					)
				}

				return r.text();

			})
			.then((markup) => {
				return this.fromString( markup )
			})

	}
	static fromString( source, params ){
		let template = document.createElement('template');
		template.innerHTML = source;

		return new this( template, params );
	}

	// 

	static getEffectiveInstance(){
		return this.#instances[ this.#effective_index ];
	}


	static _initDefaults(){

		this._defaults = {
			on: EventsSet.init('open_start','open_end')
		}
		
	}

}


